import { TextField } from "@material-ui/core"
import FormControl from "@material-ui/core/FormControl"
import React, { useRef, useState } from "react"
import { useStyles } from './otp-token-entry.styles'

type Props = {
    length: number,
    allowNonDigits?: boolean,
    onTokenEntered: (token: string) => void,
    onTokenUpdated?: (token: string) => void
}

const OtpTokenEntry = (props: Props) => {
    const {
        length,
        allowNonDigits = false,
        onTokenEntered,
        onTokenUpdated
    } = props

    const classes = useStyles()
    const [characters, setCharacters] = useState<string[]>(new Array<string>(length).fill(''))
    const inputRefs = useRef<(HTMLInputElement | null)[]>(new Array(length))

    const handleCharacterChange = (character: string, index: number) => {
        if (!allowNonDigits && isNaN(parseInt(character, 10))) {
            return
        }

        let newCharacters = characters
        newCharacters[index] = character

        setCharacters([...newCharacters])
        if (onTokenUpdated) {
            onTokenUpdated(newCharacters.join(''))
        }

        if (newCharacters.every(x => x && x !== '')) {
            onTokenEntered(newCharacters.join(''))
        }

        if (index >= length - 1) {
            return
        }

        if (!character || character === '') {
            return
        }

        inputRefs.current[index + 1]?.focus()
        if (newCharacters[index + 1] && newCharacters[index + 1] !== '') {
            selectExistingCharacter(index + 1)
        }
    }

    const selectExistingCharacter = (index: number) => {
        inputRefs.current[index]?.focus()
        inputRefs.current[index]?.select()
    }

    const handlePaste = (e: ClipboardEvent, index: number) => {
        const data = e.clipboardData?.getData('Text') ?? ''
        const length = data.length

        for (var i = 0; i < length; ++i) {
            handleCharacterChange(data[i], i + index)
        }
    }

    return <div className={classes.root}>
        {characters.map((value, index) => (
            <FormControl
                className={classes.formControl}
                key={`character-${index}`}
            >
                <TextField
                    variant="outlined"
                    className={classes.textField}
                    inputProps={{
                        className: classes.input,
                        maxLength: 1,
                        ref: (ref: HTMLInputElement | null) => inputRefs.current[index] = ref,
                        onPaste: e => handlePaste((e as unknown) as ClipboardEvent, index)
                    }}
                    onClick={e => selectExistingCharacter(index)}
                    value={value}
                    onChange={e => handleCharacterChange(e.target.value, index)}
                    tabIndex={index}
                />
            </FormControl>
        ))}
    </div>
}

export default OtpTokenEntry